module.exports = __webpack_public_path__ + "static/media/envelope_mobile.fda520b0.png";